var map = {
	"./swiper_next.svg": 15212,
	"./swiper_prev.svg": 43152,
	"./vr/vr_desc.svg": 20228,
	"./vr/vr_loop_off.svg": 90553,
	"./vr/vr_loop_on.svg": 51897,
	"./vr/vr_music_off.svg": 72335,
	"./vr/vr_music_on.svg": 36373,
	"./vr/vr_narrow.svg": 30722,
	"./vr/vr_scene_off.svg": 58248,
	"./vr/vr_scene_on.svg": 59519,
	"./vr/vr_screen.svg": 54214,
	"./vr/vr_share.svg": 63410,
	"./vr/vr_star_after.svg": 46334,
	"./vr/vr_star_before.svg": 25286,
	"./vr/vr_voice_off.svg": 24724,
	"./vr/vr_voice_on.svg": 21129,
	"./vr/vr_vr.svg": 43509,
	"./wechat.svg": 50237
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49566;